import { jsxs as r, jsx as a } from "react/jsx-runtime";
import { Container as i, Overlay as n, Spinner as e } from "./styles.js";
const s = ({ className: o }) => /* @__PURE__ */ r(i, { "aria-label": "Loading...", role: "status", className: o, children: [
  /* @__PURE__ */ a(n, {}),
  /* @__PURE__ */ a(e, {})
] });
s.displayName = "Loading";
export {
  s as Loading
};
//# sourceMappingURL=Loading.js.map
